import { render, staticRenderFns } from "./Analogies.component.vue?vue&type=template&id=707a9136&scoped=true&"
import script from "./Analogies.component.vue?vue&type=script&lang=js&"
export * from "./Analogies.component.vue?vue&type=script&lang=js&"
import style0 from "./Analogies.component.vue?vue&type=style&index=0&id=707a9136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707a9136",
  null
  
)

export default component.exports